/**
 * CRM Tasks API
 * Task management operations
 */

import { crmGet, crmPost, crmPut, crmDelete } from './crmConfig';

/**
 * Fetch all tasks
 * @param {Object} params - Optional query parameters
 */
export const fetchTasks = async (params) => {
  const response = await crmGet('/api/tasks', params);
  return response.data;
};

/**
 * Create a new task
 * @param {Object} data - Task data
 */
export const createTask = async (data) => {
  const response = await crmPost('/api/tasks', data);
  return response.data;
};

/**
 * Update a task
 * @param {string} id - Task ID
 * @param {Object} data - Task data to update
 */
export const updateTask = async (id, data) => {
  const response = await crmPut(`/api/tasks/${id}`, data);
  return response.data;
};

/**
 * Delete a task
 * @param {string} id - Task ID
 */
export const deleteTask = async (id) => {
  const response = await crmDelete(`/api/tasks/${id}`);
  return response.data;
};
